var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"ratings-circles"},_vm._l((_vm.length),function(n){return _c('li',{key:n,staticClass:"circle",class:{
      filled: n <= _vm.rating,
      half: _vm.rating+.5 === n,
    }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }